/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Sorting field options
 * @export
 */
export const SortingFieldEnum = {
    /**
    * Creation time descending (default)
    */
    CreationTimeDesc: 0,
    /**
    * Creation time ascending
    */
    CreationTime: 1,
    /**
    * Last name ascending
    */
    Nom: 2,
    /**
    * Last name descending
    */
    NomDesc: 3,
    /**
    * First name ascending
    */
    Prenom: 4,
    /**
    * First name descending
    */
    PrenomDesc: 5,
    /**
    * Email ascending
    */
    Email: 6,
    /**
    * Email descending
    */
    EmailDesc: 7,
    /**
    * Company designation ascending
    */
    Designation: 8,
    /**
    * Company designation descending
    */
    DesignationDesc: 9
} as const;
export type SortingFieldEnum = typeof SortingFieldEnum[keyof typeof SortingFieldEnum];


export function instanceOfSortingFieldEnum(value: any): boolean {
    for (const key in SortingFieldEnum) {
        if (Object.prototype.hasOwnProperty.call(SortingFieldEnum, key)) {
            if (SortingFieldEnum[key as keyof typeof SortingFieldEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SortingFieldEnumFromJSON(json: any): SortingFieldEnum {
    return SortingFieldEnumFromJSONTyped(json, false);
}

export function SortingFieldEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortingFieldEnum {
    return json as SortingFieldEnum;
}

export function SortingFieldEnumToJSON(value?: SortingFieldEnum | null): any {
    return value as any;
}

export function SortingFieldEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): SortingFieldEnum {
    return value as SortingFieldEnum;
}

